import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do medical and dental practices attract new patients online?",
    "a": "Local SEO plus a tuned Google Business Profile plus procedure-specific pages. Patients search by procedure ('Invisalign', 'dental implants', 'annual physical') — pages that rank for each procedure capture every search intent."
  },
  {
    "q": "Is SEO worth it when you take insurance?",
    "a": "Yes — insurance directories send price-shoppers. SEO sends patients who chose you. The lifetime value gap between the two is enormous."
  },
  {
    "q": "Should we run Google Ads for elective procedures?",
    "a": "Yes — implants, Invisalign, cosmetic, and aesthetic procedures have strong ROAS. CPCs are high but case values justify the spend with proper tracking."
  },
  {
    "q": "Are HIPAA considerations handled?",
    "a": "Yes — forms, analytics, and ad tracking are all configured to respect PHI. We work with healthcare compliance officers when needed."
  },
  {
    "q": "Do you market specialty practices?",
    "a": "Yes — ortho, oral surgery, periodontics, dermatology, and other specialty practices are core to what we do. Each gets a procedure-deep build."
  }
];

export const Route = createFileRoute("/medical-dental-marketing-colorado")({
  head: () =>
    industryMarketingHead("Medical & Dental", "medical or dental practice", "medical-dental-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Medical & Dental"}
      industryLower={"medical or dental practice"}
      slug={"medical-dental-marketing-colorado"}
      subheadline={"We help Colorado medical and dental practices fill the schedule with new patients — across general practice, specialty, and aesthetic procedures."}
      painPoints={["New-patient flow has slowed and referrals aren't filling the gap","Insurance directory leads are unqualified or already shopping competitors","Your site doesn't reflect the quality of care patients get in your chair"]}
      serviceDescriptions={{
        seo: "Rank for general dentistry, implants, ortho, cosmetic, primary care, and specialty searches across every Colorado market.",
        googleMaps: "Own 'dentist near me' and 'doctor near me' in the Map Pack with reviews that build trust.",
        webDesign: "Patient-friendly sites with online scheduling, insurance info, and procedure pages that convert.",
        ppc: "High-margin Google Ads for implants, ortho, cosmetic, and elective procedures with strong ROAS.",
        geoAi: "Get cited when patients ask ChatGPT 'best dentist in Colorado Springs' or 'family doctor near me'.",
        socialMedia: "Trust-building content from your team that converts shoppers into booked appointments.",
      }}
      testimonial={{"quote":"New-patient calls doubled in five months. The implant page alone pays for the whole engagement every month.","role":"Practice Owner, General Dentistry","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Medical & dental marketing in Colorado Springs","description":"New-patient marketing for practices across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Medical & dental marketing in Denver","description":"Compete for new patients across Denver's saturated provider market."},{"to":"/boulder-digital-marketing","label":"Medical & dental marketing in Boulder","description":"Reach Boulder's health-conscious patient base."}]}
    />
  ),
});
